import axios from 'axios';

// Fallback to production API if env var is missing
// This prevents "localhost" issues on client devices
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'; 

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('imoonusel_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getHomeData = async () => {
  try {
    const response = await api.get('/get_home_data.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching home data:', error);
    return null;
  }
};

export const getStaticContent = async (page) => {
  try {
    const response = await api.get(`/get_static_content.php?page=${page}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching static content:', error);
    return null;
  }
};

export const getArticles = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/get_articles.php?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching articles:', error);
    return null;
  }
};

export const getArticleBySlug = async (slug) => {
  try {
    const response = await api.get(`/get_article_detail.php?slug=${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching article detail:', error);
    return null;
  }
};

export const getContactData = async () => {
  try {
    const response = await api.get('/get_contact_data.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching contact data:', error);
    return null;
  }
};

export const getAboutData = async () => {
  try {
    const response = await api.get('/get_about_data.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching about data:', error);
    return null;
  }
};

export const getLoker = async (page = 1, limit = 10, search = '') => {
  try {
    const response = await api.get(`/get_loker.php?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching loker:', error);
    return null;
  }
};

export const getLokerDetail = async (id) => {
  try {
    const response = await api.get(`/get_loker.php?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching loker detail:', error);
    return null;
  }
};

export const applyJob = async (formData) => {
  try {
    const response = await api.post('/apply_job.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error; // Re-throw to handle in component
  }
};

export default api;